import { createDocumentPDFGenerator } from './documentReportBase';

export const generateTaxInvoicePDF = createDocumentPDFGenerator('ใบกำกับภาษี', '#0EA5E9');
